import {
	Component,
	OnInit,
	AfterViewInit,
	OnChanges,
	NgZone,
} from "@angular/core";
import { Router } from "@angular/router";
import * as L from "leaflet";
import { tileLayer } from "leaflet";
import { MAP_PIN_ICONS } from "src/app/_core/constants/leaflet-map.constants";

@Component({
	selector: "app-cebe-map-card",
	templateUrl: "./cebe-map-card.component.html",
	styleUrls: ["./cebe-map-card.component.scss"],
})
export class CebeMapCardComponent implements OnInit, AfterViewInit, OnChanges {
	// Maps
	public options: any;
	public map: L.Map;
	public layers: any = [];
	public center: L.LatLng;
	public fitBounds: L.LatLngBounds;
	public layersControl;

	constructor(private readonly zone: NgZone, private readonly router: Router) {}

	// Events
	ngOnInit(): void {}

	ngAfterViewInit(): void {
		// Map setup when needed
	}

	ngOnChanges() {
		// Map initialization when needed
	}

	onMapReady(map: L.Map) {
		this.map = map;
		window.onload = window.onresize = function () {
			map.invalidateSize();
		};
	}

	// Private methods
	private _setupMapSettings() {
		this.options = {
			layers: [
				tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
					maxZoom: 18,
					minZoom: 3,
					attribution: "",
				}).addTo(this.map),
			],
			zoomControl: false,
		};
	}

	private _initMap(): void {
		this.layers = [];
		const arrayOfLatLngs = [];

		const {
			pin01: pinIcon01,
			pin02: pinIcon02,
			pin03: pinIcon03,
			pin04: pinIcon04,
			pin05: pinIcon05,
			pin06: pinIcon06,
			pin07: pinIcon07,
		} = MAP_PIN_ICONS;

		/*         if (this.sites) {
            for (let site of this.sites) {
                if (!site.latitude || !site.longitude) {
                    continue;
                }
                var icon: L.Icon;
                switch (site.projectType) {
                    case "EBAR": icon = pinIcon03; break;
                    case "EDAR": icon = pinIcon04; break;
                    case "ETAP": icon = pinIcon02; break;

    /*         if (this.sites) {
            for (let site of this.sites) {
                if (!site.latitude || !site.longitude) {
                    continue;
                }
                var icon: L.Icon;
                switch (site.projectType) {
                    case "EBAR": icon = pinIcon03; break;
                    case "EDAR": icon = pinIcon04; break;
                    case "ETAP": icon = pinIcon02; break;
                    case "IDAM": icon = pinIcon01; break;
                    case "REDI": icon = pinIcon05; break;
                    case "SRIN":
                    case "SRAB":
                    case "SRSA":
                    case "Ofic":
                    case "OFICINA":
                        icon = pinIcon06; break;
                    default: icon = pinIcon07; break;
                }

                arrayOfLatLngs.push([parseFloat(site.latitude), parseFloat(site.longitude)]);

                var component = this;
                this.layers.push(L.marker([parseFloat(site.latitude), parseFloat(site.longitude)], {
                    icon: icon,
                    title: site.code
                })
                    .bindTooltip(
                        site.serviceName + " / " + site.name,
                        {
                        }
                    )
                    .on('click', function (e) {
                        component.zone.run(() => {
                            component.router.navigate(['/site/' + e.target.options.title]);
                        });
                    })
                );
        }

        if (arrayOfLatLngs && arrayOfLatLngs.length > 0) {
            this.fitBounds = new L.LatLngBounds(arrayOfLatLngs);
            this.map.fitBounds(this.fitBounds);
        } */
	}
}
